import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { WarningCircle } from "@phosphor-icons/react";
import { api, getUser } from "@/lib/api";

/** Banner global: alerta quando a integração Bling está desconectada
 *  (pedidos novos param de ser importados silenciosamente). */
export const BlingHealthBanner = () => {
  const [health, setHealth] = useState(null);
  const navigate = useNavigate();
  const user = getUser();

  useEffect(() => {
    let alive = true;
    const check = () => {
      api.get("/bling/health")
        .then(({ data }) => alive && setHealth(data))
        .catch(() => {}); // silencioso — banner é best-effort
    };
    check();
    const t = setInterval(check, 5 * 60 * 1000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  if (!health) return null;

  const fmtDt = (iso) => {
    if (!iso) return null;
    try {
      return new Date(iso).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
    } catch {
      return null;
    }
  };
  const isAdmin = user?.role === "admin";

  // Conectado mas o sync está FALHANDO (ex.: 429 rate limit do Bling) —
  // sem este aviso a falha é silenciosa: tudo parece saudável e nada importa.
  if (health.connected && health.last_sync_error) {
    return (
      <div className="bg-amber-500 text-black px-4 py-2 flex items-center gap-3 flex-wrap text-sm"
        data-testid="bling-sync-error-banner" title={health.last_sync_error}>
        <WarningCircle size={18} weight="fill" className="shrink-0" />
        <span className="font-semibold">
          Bling conectado, mas a sincronização está FALHANDO ({health.last_sync_error})
          {fmtDt(health.last_sync_error_at) ? ` desde ${fmtDt(health.last_sync_error_at)}` : ""} — pedidos novos podem não estar entrando.
        </span>
        {isAdmin && (
          <button
            onClick={() => navigate("/settings/bling")}
            className="ml-auto bg-black text-amber-400 font-bold text-xs px-3 py-1 rounded hover:bg-zinc-800"
            data-testid="bling-banner-diagnostic-btn"
          >
            Ver diagnóstico
          </button>
        )}
      </div>
    );
  }

  if (health.connected) return null;

  const since = fmtDt(health.disconnected_at) || fmtDt(health.last_orders_sync_at);

  return (
    <div className="bg-[#E60000] text-white px-4 py-2 flex items-center gap-3 flex-wrap text-sm"
      data-testid="bling-disconnected-banner" title={health.last_refresh_error || undefined}>
      <WarningCircle size={18} weight="fill" className="shrink-0" />
      <span className="font-semibold">
        Bling DESCONECTADO{since ? ` desde ${since}` : ""} — pedidos novos NÃO estão sendo importados.
      </span>
      {isAdmin ? (
        <button
          onClick={() => navigate("/settings/bling")}
          className="ml-auto bg-white text-[#E60000] font-bold text-xs px-3 py-1 rounded hover:bg-zinc-100"
          data-testid="bling-banner-reconnect-btn"
        >
          Reconectar agora
        </button>
      ) : (
        <span className="ml-auto text-xs opacity-90">Avise o administrador para reconectar em Configurações → Bling.</span>
      )}
    </div>
  );
};

export default BlingHealthBanner;
